<template>
  <a-modal
    width="80%"
    wrapClassName="full-modal"
    :dialog-style="{ top: '20px' }"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('hideModal')"

    :afterClose="afterHideEditModal"
  >
    <a-row :gutter="24" style="height: 100%">
      <a-col :span="6" style="height: 100%">
        <div class="content-panle bg-white" style="height: 100%">
          <SingleTreeWithSearch
            ref="treeArea"
            :selectedData="targetOrg"
            :mixNodeName="false"
            @update:selectedOrg="handleSelectedOrg"
          ></SingleTreeWithSearch>
        </div>
      </a-col>
      <a-col :span="18" style="height: 100%">
        <div class="content-panle bg-white" style="height: 100%">
          <div style="height: 75px">
            <div class="">
              组织机构：{{ modalDeviceDeptName }}
            </div>
            <div class="" style="margin-top: 10px">
              办公地点：{{ deptAddress }}
            </div>
          </div>
          <div style="height: calc(100% - 75px); width: 100%">
            <tmap-map
              ref="mapContainer"
              mapKey="2PHBZ-WWL6H-ZMWDR-W5NJO-XX7M7-CAFI2"
              :events="events"
              :center="center"
              :zoom="zoom"
              :doubleClickZoom="doubleClickZoom"
              :control="control"
            >
              <tmap-multi-marker
                :styles="markerStyles"
                :geometries="geometries"
                ref="markers"
                @click="print"
                @dblclick="print"
              />
            </tmap-map>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>

import SingleTreeWithSearch from '@/components/SingleTreeWithSearch'
import { deleteSelectedRow } from '../../../utils/utils'

export default {
  name: 'NavigationSettingModal',
  components: {
    SingleTreeWithSearch
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      zoom: 15,
      center: {
        lat: 30.657706,
        lng: 104.066116
      },
      events: {
        click: this.print,
        dblclick: this.print,
      },
      control: {
        scale: {},
        zoom: {
          position: 'bottomRight',
        },
      },
      doubleClickZoom: false,
      targetOrg: null, // 组织树中选中的对象
      deptAddress: '',
      modalDeviceDeptName: '',
      markerStyles: {
        "marker":{
          width: 25,
          height: 35,
          anchor: { x: 10, y: 30 }, // 描点位置
          src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/start.png',
        }
      },
      geometries: [
        {
          position: this.center,
          styleId: 'marker',
          id: 'marker',
        },
      ],
    }
  },
  mounted() {

  },
  watch: {},
  methods: {
    print(e) {
      if (e.poi){
        // 经纬度
        // 地理位置
      }
    },
    // 选定一个组织
    handleSelectedOrg(data) {
      // console.log('-------handleSelectedOrg--------', data);
      this.targetOrg = data
      this.modalDeviceDeptName = data.nameList.join(' / ')
      deleteSelectedRow(undefined, this.selectedRowKeys, this.selectedRowItems)
      //设置为
      //下图为地图选点
    },
    handlerSubmit() {
    },
    // 生成设备标组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.confirmLoading = false
    },
  }
}
</script>

<style scoped>
</style>
